<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="status-cliente-container container py-4">
  <div class="row mb-4">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <h2 class="fw-bold mb-0">Status dos Clientes</h2>
      <button class="btn btn-primary d-flex align-items-center gap-2 shadow-sm" (click)="openModal(formModal, true)">
        <i class="fa fa-plus"></i> Novo Status
      </button>
    </div>
  </div>

  <div class="card shadow-sm mb-4">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th style="width: 80%">Nome</th>
              <th style="width: 20%" class="text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let status of statusList">
              <td class="fs-5">{{ status.nome }}</td>
              <td class="text-center">
                <button class="btn btn-sm btn-outline-warning me-2" (click)="editarStatus(status); openModal(formModal)">
                  <i class="fa fa-edit"></i> Editar
                </button>
              </td>
            </tr>
            <tr *ngIf="statusList.length === 0">
              <td colspan="2" class="text-center text-muted py-4">Nenhum status cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <ng-template #formModal>
    <div class="modal-header bg-primary text-white">
      <h4 class="modal-title">{{ statusSelecionado ? 'Editar Status' : 'Novo Status' }}</h4>
      <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modalRef.dismiss()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="cadastroForm" (ngSubmit)="onSubmit()" class="form-container">
        <div class="form-group mb-3">
          <label for="nome" class="form-label fw-semibold">Nome do Status</label>
          <input 
            type="text" 
            id="nome" 
            formControlName="nome" 
            class="form-control form-control-lg"
            placeholder="Digite o nome do status">
        </div>
        <div class="d-flex justify-content-end gap-2 mt-4">
          <button type="button" class="btn btn-outline-secondary" (click)="modalRef.dismiss()">
            <i class="fa fa-times"></i> Cancelar
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="!cadastroForm.valid">
            <i class="fa fa-save"></i> Salvar
          </button>
        </div>
      </form>
    </div>
  </ng-template>
</div> 